import React from "react";
import {
  ICreateOpportunityError,
  IEditOpportunity,
  IOpportunity,
} from "../../../store/types/opportunity";

const useOpportunity = (opportunity: IOpportunity) => {
  const [data, dataSet] = React.useState<IEditOpportunity>({
    opportunity_name: "",
    opportunity_files: "",
    opportunity_description: "",
    expire_date: "",
    opportunity_image: "",
    opportunity_type: 0,
    id: "",
  });

  const [error, errorSet] = React.useState<ICreateOpportunityError>({
    opportunity_name: "",
    opportunity_files: "",
    opportunity_description: "",
    expire_date: "",
    opportunity_image: "",
    opportunity_type: "",
  });

  const onLoad = React.useCallback(() => {
    if (!opportunity) return;
    const opportunityFiles =
      opportunity.opportunity_files ??
      opportunity.opportunities_files ??
      opportunity.opportunity_file ??
      "";
    const expireDate =
      opportunity.expire_date instanceof Date
        ? opportunity.expire_date.toISOString()
        : String(opportunity.expire_date || "");
    dataSet({
      opportunity_name: opportunity.opportunity_name || "",
      opportunity_files: Array.isArray(opportunityFiles)
        ? (opportunityFiles[0] ?? "")
        : opportunityFiles,
      opportunity_description: opportunity.opportunity_description || "",
      expire_date: expireDate,
      opportunity_image: opportunity.opportunity_image || "",
      opportunity_type:
        opportunity.type?.id || Number(opportunity.opportunity_type) || 0,
      id: String(opportunity.id),
    });
  }, [opportunity]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return {
    data,
    error,
    dataSet,
    errorSet,
  };
};

export default useOpportunity;
